/* tslint:disable */
/* eslint-disable */
/**
 * Ion.Reporting.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ReportsStatisticAnalysis
 */
export interface ReportsStatisticAnalysis {
  /**
   *
   * @type {number}
   * @memberof ReportsStatisticAnalysis
   */
  readonly count?: number;
  /**
   *
   * @type {number}
   * @memberof ReportsStatisticAnalysis
   */
  readonly mean?: number;
  /**
   *
   * @type {number}
   * @memberof ReportsStatisticAnalysis
   */
  readonly variance?: number;
  /**
   *
   * @type {number}
   * @memberof ReportsStatisticAnalysis
   */
  readonly standardDeviation?: number;
  /**
   *
   * @type {number}
   * @memberof ReportsStatisticAnalysis
   */
  readonly skewness?: number;
  /**
   *
   * @type {number}
   * @memberof ReportsStatisticAnalysis
   */
  readonly kurtosis?: number;
  /**
   *
   * @type {number}
   * @memberof ReportsStatisticAnalysis
   */
  readonly maximum?: number;
  /**
   *
   * @type {number}
   * @memberof ReportsStatisticAnalysis
   */
  readonly minimum?: number;
  /**
   *
   * @type {number}
   * @memberof ReportsStatisticAnalysis
   */
  readonly total?: number;
}

export function ReportsStatisticAnalysisFromJSON(json: any): ReportsStatisticAnalysis {
  return ReportsStatisticAnalysisFromJSONTyped(json, false);
}

export function ReportsStatisticAnalysisFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ReportsStatisticAnalysis {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    count: !exists(json, "count") ? undefined : json["count"],
    mean: !exists(json, "mean") ? undefined : json["mean"],
    variance: !exists(json, "variance") ? undefined : json["variance"],
    standardDeviation: !exists(json, "standardDeviation") ? undefined : json["standardDeviation"],
    skewness: !exists(json, "skewness") ? undefined : json["skewness"],
    kurtosis: !exists(json, "kurtosis") ? undefined : json["kurtosis"],
    maximum: !exists(json, "maximum") ? undefined : json["maximum"],
    minimum: !exists(json, "minimum") ? undefined : json["minimum"],
    total: !exists(json, "total") ? undefined : json["total"],
  };
}

export function ReportsStatisticAnalysisToJSON(value?: ReportsStatisticAnalysis | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {};
}
